import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  justify-content: space-between;
  align-items: center;
  /* width: 80%; */
  color: #000;
  /* margin: 0 auto 10px; */
`;

export const Center = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const Input = styled.input`
  width: 100%;
  height: 42px;
  padding: .67857143em 1em;
  outline: 0;
  background:#FFFFFF;
  color: rgba(0,0,0,.87);
  font-size: 13px;
  font-family: sans-serif;
  font-weight: 400;
  border: 1px solid rgba(34,36,38,.15);
  border-radius: 4px;
  -webkit-appearance: none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color .1s ease,border-color .1s ease;
`;
